<template>
    <i class="fa fa-image" :style="{opacity: ad.content ? 1 : 0.2}" v-tooltip="ad.content"></i>
</template>

<script>
    export default {
        props: {
            ad: {
                type: Object,
                required: true
            }
        }
    }
</script>
